import { Box, Typography, useTheme } from "@mui/material";

import Card from "components/Card";
import { DefaultUrlWeb } from "config/Configuration";
import NumberFormats from "components/NumberFormats";

function PortfolioInvestmentBox({ portfolioInvestmentItem }) {
  const theme = useTheme();

  return (
    <Card shadow={theme.shadows[1]}>
      <Box dir="ltr" display="flex" mb={2}>
        <img
          width={"25px"}
          src={`${DefaultUrlWeb}${portfolioInvestmentItem?.imageUrl}`}
          alt={portfolioInvestmentItem?.name}
        />

        <Typography
          variant="h4"
          s
          color="text.main"
          fontWeight="600"
          marginLeft={1}
        >
          {portfolioInvestmentItem?.name}
        </Typography>
      </Box>

      <Typography component="span" dir="ltr">
        <Typography variant="h6" color="text.secondary">
          Inventory Available Now
        </Typography>
        <Typography
          py={1}
          variant="h6"
          color={
            portfolioInvestmentItem.valueStart > 0
              ? "success.main"
              : portfolioInvestmentItem.valueStart < 0
              ? "error.main"
              : "text.main"
          }
        >
          {portfolioInvestmentItem.valueStart > 0 && "+"}
          <NumberFormats value={portfolioInvestmentItem.valueStart} />
        </Typography>
      </Typography>

      <Typography component="span" dir="ltr">
        <Typography variant="h6" color="text.secondary">
          Deposit & Withdraw
        </Typography>
        <Typography
          py={1}
          variant="h6"
          color={
            portfolioInvestmentItem.valueDepositWithdraw > 0
              ? "success.main"
              : portfolioInvestmentItem.valueDepositWithdraw < 0
              ? "error.main"
              : "text.main"
          }
        >
          {portfolioInvestmentItem.valueDepositWithdraw > 0 && "+"}
          <NumberFormats value={portfolioInvestmentItem.valueDepositWithdraw} />
        </Typography>
      </Typography>

      <Typography component="span" dir="ltr">
        <Typography variant="h6" color="text.secondary">
          Inventory at the start of the report
        </Typography>
        <Typography
          py={1}
          variant="h6"
          color={
            portfolioInvestmentItem.valueEnd > 0
              ? "success.main"
              : portfolioInvestmentItem.valueEnd < 0
              ? "error.main"
              : "text.main"
          }
        >
          {portfolioInvestmentItem.valueEnd > 0 && "+"}
          <NumberFormats value={portfolioInvestmentItem.valueEnd} />
        </Typography>
      </Typography>
    </Card>
  );
}

export default PortfolioInvestmentBox;
